export function WithHook<THook extends (...args: never[]) => unknown>({
    hook,
    hookArgs,
    children,
}: {
    hook: THook;
    hookArgs: NoInfer<Parameters<THook>>;
    children: NoInfer<((args: ReturnType<THook>) => React.ReactNode) | React.ReactNode>;
}) {
    const renderProps = hook(...hookArgs) as ReturnType<THook>;
    return <>{typeof children === 'function' ? children(renderProps) : children}</>;
}
